import { ActionTypes } from '../constants/index';

export const getPostReportDetail = (payload: any) => ({
  type: ActionTypes.POST_REPORT_DETAIL_REQUEST,
  payload: {
    id: payload.id,
    page: payload.page + 1,
    rowsPerPage: payload.rowsPerPage,
    startDate: payload.startDate,
    endDate: payload.endDate,
    userType: payload.userType,
    search: payload.search,
    isSortByUserName: payload.isSortByUserName,
    isSortByRegister: payload.isSortByRegister,
  },
});
